import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { IconSearch } from '@tabler/icons-react';
import { MySwal } from '../../../library/swal';
import { useLocation } from 'react-router-dom';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";

const FilterRiskHeatmapComp = (props) => {
  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown is always above other components
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, // Apply z-index to the dropdown menu itself
    }),
  };

  const [listBobot, setlistBobot] = useState([]);
  const [startDate, setstartDate] = useState('');
  const [endDate, setendDate] = useState('');
  const [idRiskBobot, setidRiskBobot] = useState('');

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchMatriksBobot = async () => {
    try {
      const options = {
        url: `/risk-bobot/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      setlistBobot(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleFilter = () => {
    props.doFilter(idRiskBobot, startDate, endDate);
  };

  useEffect(() => {
    fetchMatriksBobot();
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  return (
    <>
      {/*begin::Post*/}
      <div className="post d-flex flex-column-fluid mb-4" id="kt_post">
        {/*begin::Container*/}
        <div id="kt_content_container" className="container-xxl">
          {/*begin::Row*/}
          <div className="row gy-5 g-xl-8">
            {/*begin::Col*/}
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-3 col-12">
                      <div className="mb-3">
                        <div className="col-12">
                          <label className="form-label">Tanggal Awal</label>
                          <input
                            type="date"
                            className="form-control row-cols-3"
                            id="startDate"
                            autoComplete="off"
                            onChange={(e) => setstartDate(e.target.value)}
                            value={startDate}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-12">
                      <div className="mb-3">
                        <div className="col-12">
                          <label className="form-label">Tanggal Akhir</label>
                          <input
                            type="date"
                            className="form-control row-cols-3"
                            id="endDate"
                            autoComplete="off"
                            onChange={(e) => setendDate(e.target.value)}
                            value={endDate}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-12">
                      <div className="mb-3">
                        <div className="col-12">
                          <label className="form-label">Bobot</label>
                          <select
                            className="form-select"
                            id="idRiskBobot"
                            onChange={(e) => setidRiskBobot(e.target.value)}
                          >
                            <option value="" disabled selected>
                              Pilih Frekuensi
                            </option>
                            <option value="all">Lihat Semua</option>
                            {listBobot.map((d) => (
                              <option key={d.idRiskBobot} value={d.idRiskBobot}>
                                {d.probability}
                                {', '}
                                {d.impact}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-12">
                      <div className="mt-9">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleFilter}
                        >
                          <IconSearch stroke={2} /> Cari
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end::Col*/}
          </div>
          {/*end::Row*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Post*/}
    </>
  );
};

export default FilterRiskHeatmapComp;
